import { AuthorLine } from '@components/atoms/AuthorLine/AuthorLine';
import type { User } from '@lib/graphql/generated';
import { DateTime, type PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { PropsWithChildren } from 'react';

export interface TextCardProps
  extends PropsWithClassProps<'text' | 'authorLine' | 'date' | 'names'>,
    PropsWithChildren {
  text: string;
  authors: User[];
  date: Date;
}

export const TextCard = ({ children, classProps, text, authors, date }: TextCardProps) => {
  return (
    <div className={classProps?.root}>
      <p className={classProps?.text}>{text}</p>
      <span>
        {authors?.length > 0 && <AuthorLine classProps={classProps} authors={authors} />}
        <p>
          <DateTime classProps={{ root: classProps?.date }} date={date} formatOptions={{ dateStyle: 'short' }} />
        </p>
      </span>
      {children}
    </div>
  );
};
